/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMetricRequest
 */
export interface UpdateMetricRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMetricRequest
     */
    name?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateMetricRequest
     */
    sourceUnit?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMetricRequest
     */
    lc?: Array<string>;
    /**
     * all features that should be assigned to the metric. an empty array removes all features, null will change nothing
     * @type {Array<string>}
     * @memberof UpdateMetricRequest
     */
    licenseFeatures?: Array<string>;
    /**
     * Minimum value filter
     * @type {number}
     * @memberof UpdateMetricRequest
     */
    min?: number;
    /**
     * Maximum value filter
     * @type {number}
     * @memberof UpdateMetricRequest
     */
    max?: number;
    /**
     * Optional link to a parent metric, if empty string, metric link gets cleared
     * @type {string}
     * @memberof UpdateMetricRequest
     */
    parentKey?: string;
    /**
     * Optional flag to set metric (in)active
     * @type {boolean}
     * @memberof UpdateMetricRequest
     */
    inactive?: boolean;
}

/**
 * Check if a given object implements the UpdateMetricRequest interface.
 */
export function instanceOfUpdateMetricRequest(value: object): value is UpdateMetricRequest {
    return true;
}

export function UpdateMetricRequestFromJSON(json: any): UpdateMetricRequest {
    return UpdateMetricRequestFromJSONTyped(json, false);
}

export function UpdateMetricRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMetricRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'sourceUnit': json['sourceUnit'] == null ? undefined : json['sourceUnit'],
        'lc': json['lc'] == null ? undefined : json['lc'],
        'licenseFeatures': json['licenseFeatures'] == null ? undefined : json['licenseFeatures'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'parentKey': json['parentKey'] == null ? undefined : json['parentKey'],
        'inactive': json['inactive'] == null ? undefined : json['inactive'],
    };
}

export function UpdateMetricRequestToJSON(json: any): UpdateMetricRequest {
    return UpdateMetricRequestToJSONTyped(json, false);
}

export function UpdateMetricRequestToJSONTyped(value?: UpdateMetricRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sourceUnit': value['sourceUnit'],
        'lc': value['lc'],
        'licenseFeatures': value['licenseFeatures'],
        'min': value['min'],
        'max': value['max'],
        'parentKey': value['parentKey'],
        'inactive': value['inactive'],
    };
}

